module.exports = __webpack_public_path__ + "6bb4ed6ed06f8428129fb99cdcdc0903.svg";